<template>
  <div>
    <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading>

    <b-sidebar
      type="is-light"
      :fullheight="fullheight"
      :fullwidth="fullwidth"
      :overlay="overlay"
      :right="right"
      v-model="open"
    >
      <div class="p-1">
        <img :src="require('../assets/logo.svg')" />
        <p>Welcome {{currentUser.email}}</p>

        <br />
        <b-menu>
          <b-menu-list label="Menu">
            <b-menu-item icon="account" label="My Account">
              <b-menu-item label="Account Data" icon="account" tag="router-link" to="/data"></b-menu-item>
            </b-menu-item>
          </b-menu-list>

          <b-menu-list>
            <b-menu-item icon="phone" label="Contact Us">
              <a
                href="https://wa.me/23408149666253/?text='I want to enquire more about natural home of remedies"
                target="_blank"
              >
                <v-icon>mdi-whatsapp</v-icon>
              </a>
              <a href="https://web.facebook.com/Dhomeofnature" target="_blank">
                <v-icon>mdi-facebook</v-icon>
              </a>

              <a href="mailto:godswillchibuzororie@gmail.com">
                <v-icon>mdi-gmail</v-icon>
              </a>
              <v-footer padless>
                <v-col>
                  {{ new Date().getFullYear() }} —
                  <strong>Bolathedev</strong>
                </v-col>
              </v-footer>
            </b-menu-item>
          </b-menu-list>
          <b-menu-list label="Actions">
            <span @click="open = false"></span>
            <v-dialog transition="dialog-bottom-transition" max-width="320">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" @click="open = false">log-out</v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card>
                  <v-toolbar>ARE YOU SURE YOU WANT TO LOG OUT</v-toolbar>
                  <v-card-text>
                    <div class="text-h2 pa-12"></div>
                  </v-card-text>
                  <v-card-actions class="logoutactions">
                    <v-btn text @click="dialog.value = false">CANCEL</v-btn>
                    <span @click="userlogout">
                      <v-btn text @click="dialog.value = false" color="danger">
                        <p>logout</p>
                      </v-btn>
                    </span>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </b-menu-list>
        </b-menu>
      </div>
    </b-sidebar>
    <div class="mobilenavbar">
      <router-link to="/">
        <v-img :width="80" class="mobilelogo" :src="require('../assets/logo.svg')" />
      </router-link>
      <router-link class="mobileaccount" v-if="!isLoggedIn" to="/mobile-view-auth">
        <v-icon>mdi-account</v-icon>
      </router-link>
      <v-icon class="mobilelogout" @click="open = true" v-if="isLoggedIn">mdi-account-check</v-icon>
      <router-link class="mobilecart" to="/cart">
        <v-icon>mdi-cart</v-icon>
      </router-link>
    </div>
    <b-navbar fixed-top class="toolbar" collapsible shadow>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <v-img :width="80" class="logo" :src="require('../assets/logo.svg')" />
        </b-navbar-item>
      </template>
      <template slot="start"></template>

      <template slot="end">
        <router-link class="account" v-if="!isLoggedIn" to="/mobile-view-auth">
          <v-icon>mdi-account</v-icon>
        </router-link>
        <v-icon class="login" v-if="isLoggedIn" @click="open =  true">mdi-account-check</v-icon>
        <b-navbar-item tag="router-link" to="/cart">
          <v-icon>mdi-cart</v-icon>
          <sup>({{numItems}})</sup>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      open: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: false,
      dialog: false,
      isLoading: false,
      islogout: false,
      isFullPage: false
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "cartValue", "currentUser", "cartItemList"]),
    numItems() {
      return this.cartItemList.length;
    },
    userEmail() {
      return this.isLoggedIn ? this.currentUser.email : "";
    }
  },
  methods: {
    ...mapActions(["logout"]),
    userlogout() {
      this.logout()
        .then(() => {
          (this.isLoading = true),
            setTimeout(
              () =>
                this.$buefy.toast.open({
                  message: `LOG-OUT SUCCESSFUL`,
                  type: "is-success",
                  position: "is-top-right"
                }),
              2000
            );
          setTimeout(() => (this.isLoading = false), 2200);
          setTimeout(() => this.$router.push("/"), 2100);
        })
        .finally((this.isLoading = false));
    }
  }
};
</script>


<style >
.logoutactions {
  margin: 2em;
  margin-bottom: 0;
  margin-top: 0;
}
.search {
  width: 630px;
  padding-top: 1.5px;
}
.login {
  margin-right: 0.5em;
}
.nav-actions {
  display: flex;
}
.user-actions {
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 0.5em;
}
.user-logout {
  margin-left: 1em;
  margin-right: 1em;
}
.mobilelogo {
  display: none;
  width: 100px;
  padding-top: 1em;
}
.mobilenavbar {
  display: flex;
  position: fixed;
  z-index: 1;
  width: 100%;
  top: 0;
  background-color: white;
}
.mobileaccount {
  display: none;
  margin-left: 11em;
  padding-top: 2em;
  width: 100%;
}
.mobilelogout {
  display: none;
  margin-left: 8em;
  width: 100%;
}
.mobilecart {
  display: none;
  padding-top: 2em;
  width: 100%;
}
@media only screen and (max-width: 410px) {
  .toolbar {
    display: none;
  }
  .mobilelogo {
    display: block;
  }
  .mobilecart {
    display: block;
  }
  .mobileaccount {
    display: block;
  }
  .mobilelogout {
    display: block;
  }
}
@media only screen and (min-width: 411px) {
  .toolbar {
    display: none;
  }
  .mobilelogo {
    display: block;
  }
  .mobilecart {
    display: block;
    padding-top: 2em;
    width: 100%;
  }
  .mobileaccount {
    display: block;
  }
  .mobilenavbar {
    width: 100%;
  }
  .mobilelogout {
    display: flex;
    margin-left: 11em;
    width: 100%;
  }
}
@media only screen and (min-width: 1025px) {
  .toolbar {
    display: flex;
  }
}
</style>
